import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Switch, useParams } from "react-router";
import { NavLink, Route } from "react-router-dom";
import { ArrowRight, ProfileMenu, ProfileModal } from "src/components";
import { useWindowDimension } from "src/hooks";
import { _ } from "src/services";
import { ConfigInit } from "src/store";
import { NotFound } from "./not.found";
import { ProfileDevices } from "./profile.devices";
import { ProfileFavorites } from "./profile.favorites";
import { ProfileInfo } from "./profile.info";
import { ProfilePackages } from "./profile.packages";
import { ProfilePurchases } from "./profile.purchases";

export const Profile: React.FC = () => {

    const { route } = useParams<{ route?: string }>();
    const [width] = useWindowDimension();
    const config: ConfigInit = useSelector((state: any) => state.ConfigState);

    const [packagesRoute, setPackagesRoute] = useState(width > 767 ? ["/profile", "/profile/subscription"] : ["/profile/subscription"]);

    const title = route === "subscription" ? _("yourPackages") :
        route === "purchases" ? _("purchases") :
            route === "devices" ? _("devices") :
                route === "favorites" ? _("favorites") :
                    route === "edit" ? _("editProfileTitle") : "";

    const routeFound = [
        "", "subscription", "purchases",
        config.config.appSetting.devicesProfileEnabled ? "devices" : "",
        config.config.appSetting.favoritesEnabled ? "favorites" : "",
        "edit", undefined].includes(route);

    useEffect(() => {
        setPackagesRoute(width > 767 ? ["/profile", "/profile/subscription"] : ["/profile/subscription"]);
    }, [width, setPackagesRoute]);

    if (!routeFound) {
        return (<NotFound />);
    }

    return (
        <div className="page-profile app-theme2 mb-5 pb-5">
            <div className="container large-container profile-container">
                {
                    route &&
                    <NavLink to={"/profile"} className="btn btn-link text-white d-lg-none return-button">
                        <ArrowRight />
                        <span className="mr-2">{title}</span>
                    </NavLink>
                }
                <div className="row no-gutters">
                    <div className={`col-12 col-lg-4 col-xl-3 ${route ? "d-none d-lg-block" : ""}`}>
                        <ProfileMenu />
                    </div>
                    <div className={`col-12 col-lg-8 col-xl-9 ${route ? "" : "d-none d-lg-block"}`}>
                        <Switch>
                            <Route exact path={packagesRoute} component={ProfilePackages} />
                            <Route exact path={"/profile/purchases"} component={ProfilePurchases} />
                            {config.config.appSetting.devicesProfileEnabled && <Route exact path={"/profile/devices"} component={ProfileDevices} />}
                            {config.config.appSetting.favoritesEnabled && <Route exact path={"/profile/favorites"} component={ProfileFavorites} />}
                            <Route exact path={"/profile/edit"} component={ProfileInfo} />
                        </Switch>
                    </div>
                </div>
            </div>
            <ProfileModal />
        </div>
    );
};
